import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { BrandActivityMappingsComponent } from '@app/leasing-company/work-orders/pages/details/components/brand-activity-mappings/brand-activity-mappings.component';
import { map, switchMap, Observable, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { UnsavedChangesDialogComponent } from '@shared/components/unsaved-changes-dialog/unsaved-changes-dialog.component';

export function isEditingGuard(): CanDeactivateFn<BrandActivityMappingsComponent> {
  return (component: BrandActivityMappingsComponent) => {
    const brandActivityMappingsService = component.brandActivityMappingsService;
    const dialog = inject(MatDialog);

    return brandActivityMappingsService.getBrandActivityMappings().pipe(
      map(mappings => {
        const unmapped = mappings.unmapped.filter(({ isEdited }) => isEdited);
        const mapped = mappings.mapped.filter(({ isEdited }) => isEdited);

        const hasUnmappedActivities = unmapped.length > 0;
        const hasEditedMappedActivities = mapped.length > 0;

        return hasUnmappedActivities || hasEditedMappedActivities;
      }),
      switchMap(hasUnsavedChanges =>
        hasUnsavedChanges ? openConfirmationDialog(dialog) : of(true),
      ),
    );
  };
}

function openConfirmationDialog(dialog: MatDialog): Observable<boolean> {
  return dialog.open(UnsavedChangesDialogComponent, {
    width: '500px',
    height: 'auto',
    autoFocus: false,
  }).afterClosed().pipe(
    map(result => result === true),
  );
}

